module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageTitle":"Baianat Careers archive","pageDesc":"Previously available opportunities.","mantra":"Previously available opportunities."},"ar":{"pageTitle":"الفرص المتاحة","pageDesc":"قم بالاطلاع على كل الفرص المتاحة داخل بيانات وتقدم للانضمام إلى فريقنا.","mantra":"الوظائف التى كانت متاحة."}}')
  delete Component.options._Ctor
}
